import { datadogRum, RumInitConfiguration } from "@datadog/browser-rum";
import { useEffect } from "react";

type Config = Pick<RumInitConfiguration, "service" | "env" | "version"> &
    Partial<Pick<RumInitConfiguration, "applicationId" | "clientToken">>;

export function useDatadogRUM(config: Config) {
    useEffect(() => {
        const { applicationId, clientToken } = config;
        const init = datadogRum.getInitConfiguration();
        if (applicationId && clientToken && init === undefined) {
            datadogRum.init({
                ...config,
                applicationId,
                clientToken,
                site: "datadoghq.com",
                // https://www.datadoghq.com/pricing/?product=real-user-monitoring--session-replay
                sessionSampleRate: 1, // 1%
                sessionReplaySampleRate: 100, // 100%
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: "mask-user-input",
                // https://docs.datadoghq.com/real_user_monitoring/platform/connect_rum_and_traces/?tab=browserrum
                allowedTracingUrls: [
                    /https:\/\/.*\.ncsav3\.tech\/.*/,
                    /https:\/\/plus\.imgacademy\.com\/.*/,
                ],
            });
        }
    }, [config]);
}
